module.exports = __webpack_public_path__ + "img/auth-wall-short.c99ec36c.jpg";